import helpers from '@/router/helpers';
import UserRoles from '@/constants/user/roles';

export default {
    path: '/mail/delivery',
    meta: {
        title: 'Delivery',
        documentTitle: 'Mail Delivery',
        requiresAuth: true,
        mdiIcon: 'truck',
        allowedRoles: [
            UserRoles.SUPER_ADMIN,
            UserRoles.MAIL_OPERATOR,
        ],
    },
    component: helpers.getRouterView(),
    children: [
        {
            path: '',
            name: 'MailDelivery',
            meta: {
                title: 'Delivery',
                documentTitle: 'Mail Delivery',
                shouldPersistBetweenLogins: true,
                allowedRoles: [
                    UserRoles.SUPER_ADMIN,
                    UserRoles.MAIL_OPERATOR,
                ],
            },
            component: () => import( /* webpackChunkName: "MailDelivery" */ '@/views/mail/Delivery' ),
        },
        {
            path: 'transit',
            name: 'OutForDelivery',
            meta: {
                title: 'Delivery',
                documentTitle: 'Mail Delivery',
            },
            component: () => import( /* webpackChunkName: "OutForDelivery" */ '@/views/mail/delivery/OutForDelivery' ),
        },
    ],
};
